import * as React from "react";
import { ILookupDictionary } from "../../lookup/types/ILookupDictionary";
import { setDataSource } from "../../redux/reducers/RepertoireReducer";
import { IActiveAccordion } from "../../redux/types/IActiveAccordion";
import IMembersPortalComponentDataItem from "../../redux/types/IMembersPortalComponentDataItem";
import { IResultsPerPage } from "../../redux/types/IResultsPerPage";
import { ITabReduxItem } from "../../redux/types/ITabReduxItem";
import { DataSource } from "../../repertoire/types/DataSource";
import { MemberPortalSearchTypeItem } from "../../redux/types/MemberPortalSearchTypeItem";
import { IRegisteredWorkSearchQuery } from "../types/IRegisteredWorkSearchQuery";
import { IRegisteredWorkSearchResult } from "../types/IRegisteredWorkSearchResult";
import { FormatFields } from "../../redux/types/FormatFields";
import { IMyPackagesResult } from "../../repertoire/types/IMyPackagesResult";
import MemberWorksPage from "../memberWorks/MemberWorksPage";
import { SEARCH_VIEW_REGISTERED_WORKS } from "../Consts";
import { IAssigneeAgreementResult } from "../types/IAssigneeAgreementResult";
import { IPortalShareSetConfiguration } from "../types/IPortalShareSetConfiguration";
import { hideModal, showYesNoPrompt } from "../../redux/reducers/ModalReducer";
import { IMembersPortalPathInfo } from "../types/IMembersPortalPathInfo";
import { CURRENT_USER_EMAIL_KEY } from "../../redux/services/AccountSessionStorage";
import { IPortalWorkStatusConfiguration } from "../types/IPortalWorkStatusConfiguration";

export interface IRegisteredWorksPageProps {
    registeredWorksPageData: IMembersPortalComponentDataItem;
    searchViewData: IMembersPortalComponentDataItem;
    searchResultsTableData: IMembersPortalComponentDataItem;
    searchRegisteredWorks?: (query: IRegisteredWorkSearchQuery) => void;
    registeredWorkSearchResults: IRegisteredWorkSearchResult[];
    searchSuccessful: boolean;
    registeredWorksMaintenanceGeneralDataViewData: IMembersPortalComponentDataItem;
    lookupValues: ILookupDictionary;
    indexOfFirstResult?: number;
    indexOfLastResult?: number;
    loadMembersPortalFromPath: (pathInfo: IMembersPortalPathInfo, currentUserNameNumber: string, location: Location) => void;
    resultsPerPage?: number;
    currentPage?: number;
    resetPagination: (repertoireSection: string) => void;
    updatePagination: (indexOfFirstResult: number, indexOfLastResult: number, resultsPerPage: number, currentPage: number, repertoireSection: string) => void;
    getRegisteredWorkDetails: (dataSource: string, workID: number, lookupValues: ILookupDictionary, memberWorkMaintenanceDataViewData: IMembersPortalComponentDataItem, formats?: FormatFields[], includeAllMyAccounts?: boolean) => void;
    addNewDraftWorks: (lookups: ILookupDictionary, currentUserNameNumber: string, isNew?: boolean, draftWorksMaintenanceGeneralDataViewData?: IMembersPortalComponentDataItem, formats?: FormatFields[]) => void;
    sortSearchResults: (name: string, results: any) => void;
    defaultActiveAccordions?: IActiveAccordion[];
    allResultsPerPage?: IResultsPerPage[];
    updateUserPreferences: (allResultsPerPage: IResultsPerPage[], activeAccordions: IActiveAccordion[], newActiveAccordionName?: string, accordionExpanded?: boolean, componentName?: string, indexOfFirstResult?: number, indexOfLastResult?: number, resultsPerPage?: number, repertoireSection?: string) => void;
    disabled?: boolean;
    roles?: string[];
    saveRoles?: (roles: string[]) => void;
    setDataSource: typeof setDataSource;
    dataSource: string;
    activeTab?: number;
    tabs?: ITabReduxItem[];
    memberPortalSearchType: MemberPortalSearchTypeItem;
    currentUserNameNumber?: string;
    currentUserIpBaseNumber?: string;
    expandWorkResult?: (workResult: number) => void;
    expandedWorkResults?: number[];
    expandAllResults: () => void;
    expandAll: boolean;
    addToPackages?: (userName: string, entityType: string, entityIds: number[]) => IMyPackagesResult;
    customer?: string;
    getAssigneeAgreements?: () => void;
    assigneeAgreementsResult?: IAssigneeAgreementResult[];
    hideModal: typeof hideModal;
    showYesNoPrompt: typeof showYesNoPrompt;
    fullCataloguePackagePending?: boolean;
    saveInProgress?: boolean;
    getFullCataloguePackagePending?: (userName: string) => void;
    createPackageFromCriteria?: (userName: string, criteria: IRegisteredWorkSearchQuery) => void;
    packageGenerationMessage?: string;
    packageOperationInProgress?: boolean;
    portalWorkStatusConfiguration: IPortalWorkStatusConfiguration;
    getPortalWorkStatusConfiguration: () => void;
}

const RegisteredWorksPage = (props: IRegisteredWorksPageProps) => {

    const currentDataSource = DataSource.Repertoire;

    const workPackageItemIds = React.useMemo(() => {
        const activeTab = props.activeTab ?? 0;
        const packageResult: any =
            props.tabs?.[activeTab]?.myPackagesResult;

        const packages = Array.isArray(packageResult)
            ? packageResult
            : Array.isArray(packageResult?.data)
                ? packageResult.data
                : [];

        const openWorksPackage = packages.find(
            packageItem =>
                packageItem?.entityType === "Works" &&
                packageItem?.status === "Open"
        );

        return (openWorksPackage?.packageItems ?? [])
            .map((id: unknown) => Number(id))
            .filter((id: number) => Number.isFinite(id));
    }, [props.tabs, props.activeTab]);
        
    React.useEffect(() => {
        if (props.dataSource !== currentDataSource) {
        props.setDataSource(currentDataSource);
        }
    }, [props.dataSource]);

    React.useEffect(() => {
        if (!props.getFullCataloguePackagePending) return;

        const username = sessionStorage.getItem(CURRENT_USER_EMAIL_KEY);
        if (!username) return;

        props.getFullCataloguePackagePending(username);
    }, [props.getFullCataloguePackagePending]);

    React.useEffect(() => {
        props.getPortalWorkStatusConfiguration();
    }, [props.getPortalWorkStatusConfiguration]);

    return (
        <div>
				
            <MemberWorksPage
                memberWorksPageData={props.registeredWorksPageData}
                searchViewData={props.searchViewData}
                searchResultsTableData={props.searchResultsTableData}
                searchDraftWorks={props.searchRegisteredWorks}
                memberWorkSearchResults={props.registeredWorkSearchResults}
                searchSuccessful={props.searchSuccessful}
                memberWorksMaintenanceGeneralDataViewData={props.registeredWorksMaintenanceGeneralDataViewData}
                lookupValues={props.lookupValues}
                indexOfFirstResult={props.indexOfFirstResult}
                indexOfLastResult={props.indexOfLastResult}
                resultsPerPage={props.resultsPerPage}
                currentPage={props.currentPage}
                resetPagination={props.resetPagination}
                updatePagination={props.updatePagination}
                getMemberWorkDetails={props.getRegisteredWorkDetails}
                addNewDraftWorks={props.addNewDraftWorks}
                sortSearchResults={props.sortSearchResults}
                defaultActiveAccordions={props.defaultActiveAccordions}
                allResultsPerPage={props.allResultsPerPage}
                updateUserPreferences={props.updateUserPreferences}
                loadMembersPortalFromPath={props.loadMembersPortalFromPath }
                disabled={props.disabled}
                roles={props.roles}
                saveRoles={props.saveRoles}
                setDataSource={props.setDataSource}
                dataSource={currentDataSource}
                activeTab={props.activeTab}
                tabs={props.tabs}
                memberPortalSearchType={props.memberPortalSearchType}
                expandWorkResult={props.expandWorkResult}
                expandedWorkResults={props.expandedWorkResults}
                expandAllResults={props.expandAllResults}
                expandAll={props.expandAll}
                currentUserNameNumber={props.currentUserNameNumber}
                currentUserIpBaseNumber={props.currentUserIpBaseNumber}
                componentInstance={SEARCH_VIEW_REGISTERED_WORKS}
                customer={props.customer}
                addToPackages={props.addToPackages}
                getAssigneeAgreements={props.getAssigneeAgreements}
                assigneeAgreementsResult={props.assigneeAgreementsResult}
                hideModal={props.hideModal}
                showYesNoPrompt={props.showYesNoPrompt}
                fullCataloguePackagePending={props.fullCataloguePackagePending}
                createPackageFromCriteria={props.createPackageFromCriteria}
                saveInProgress={props.saveInProgress}
                packageGenerationMessage={props.packageGenerationMessage}
                packageOperationInProgress={props.packageOperationInProgress}
                packageItemIds={workPackageItemIds}
                portalWorkStatusConfiguration={props.portalWorkStatusConfiguration}
            />
            </div>
            
        );

    }

export default RegisteredWorksPage;
 